import { API_CONFIG } from '../brands/default/config';
import { URLVALIDATEVOUCHER } from '../brands/default/services';
import axios from '../components/_generic/axiosSplunk/axiosSplunk';
import { getAppPlatform } from './device';
import ErrorTrackingService from './errorTrackingService';

const vouchersService = {};

const headers = {
  accept: 'application/json',
  'app-platform': getAppPlatform(),
  brand: API_CONFIG.BRAND_HEADER,
  'content-type': 'application/json',
  'country-code': process.env.NEXT_PUBLIC_COUNTRY_CODE || 'gb',
  webapp: true,
};

vouchersService.validateVoucher = async (orderNumber, voucherCode) => {
  try {
    const resp = await axios({
      cache: false,
      headers,
      method: 'GET',
      params: {
        orderNumber,
      },
      url: `${URLVALIDATEVOUCHER}/${voucherCode}/validate`,
      validateStatus: (statusCode) => {
        return statusCode < 500;
      },
      withCredentials: true,
    });

    return resp.data;
  } catch (error) {
    ErrorTrackingService.logError(error);

    return null;
  }
};

vouchersService.updateStatus = async ({
  orderNumber,
  refundReasonId,
  status,
  voucherCode,
}) => {
  try {
    const resp = await axios({
      cache: false,
      data: { status },
      headers,
      method: 'PATCH',
      params: {
        orderNumber,
        refundReasonId,
      },
      url: `${URLVALIDATEVOUCHER}/${voucherCode}/status`,
      validateStatus: (statusCode) => {
        return statusCode < 500;
      },
      withCredentials: true,
    });

    return resp.data;
  } catch (error) {
    ErrorTrackingService.logError(error);

    return null;
  }
};

export default vouchersService;
